import * as React from "react";
const SvgFiRrLanguage = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19 4H5a5 5 0 0 0-5 5v6a5 5 0 0 0 5 5h14c2.757 0 5-2.243 5-5V9c0-2.757-2.243-5-5-5M8.12 16a.7.7 0 0 1-.682-.543L7.173 14.3H4.764l-.274 1.161a.7.7 0 0 1-1.362-.321l1.413-5.993a1.49 1.49 0 0 1 2.056-1.021c.439.184.734.606.842 1.07l1.363 5.948A.7.7 0 0 1 8.12 16M22 15c0 1.654-1.346 3-3 3h-7V6h7c1.654 0 3 1.346 3 3zm-1.5-5.384v.021c0 .34-.276.616-.616.616h-.316c-.121 1.275-.617 2.731-1.607 3.866a4.6 4.6 0 0 0 1.984.639c.315.03.555.296.555.613v.021a.617.617 0 0 1-.68.613c-1.137-.109-2.059-.489-2.808-1.022-.753.538-1.686.915-2.832 1.022a.62.62 0 0 1-.679-.614v-.021a.62.62 0 0 1 .568-.614 4.6 4.6 0 0 0 1.977-.635 6.3 6.3 0 0 1-.833-1.227.615.615 0 0 1 .549-.896h.01c.226 0 .437.122.541.322.185.352.416.691.693 1.002.818-.92 1.192-2.108 1.303-3.071h-4.191a.616.616 0 0 1-.616-.616v-.021c0-.34.276-.616.616-.616h2.257v-.384c0-.34.276-.616.616-.616h.021c.34 0 .616.276.616.616v.384h2.257c.34 0 .616.276.616.616zM6.065 9.463l.787 3.437H5.095l.811-3.437a.081.081 0 0 1 .159 0"
    />
  </svg>
);
export default SvgFiRrLanguage;
